/*
 * @Author: lishiqiao
 * @Date: 2022-01-18 14:14:18
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-13 13:43:12
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 16:59:15
     * @description: 销售量--查询顶级机构下的所有机构
     * @param {*} rootId 顶级机构id
     */
    getVolumeCompanyList(rootId) {
        const url = `/desktopReport/querySelltOrgFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:00:13
     * @description: 销售量--查询顶级机构下的所有造次
     * @param {*} rootId
     */
    getVolumePeriodList(rootId) {
        const url = `/desktopReport/querySelltPerioyFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:01:02
     * @description: 销售量--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getVolumeBreedTypeList(rootId) {
        const url = `/desktopReport/querySelltTypeFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:01:50
     * @description: 销售量--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getVolumeBreedList(rootId) {
        const url = `/desktopReport/querySelltBreedFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:07:44
     * @description: 客户应收--汇总--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getSummaryCompanyList(rootId) {
        const url = `/desktopReport/queryCustomerOrgFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:09:05
     * @description: 客户应收--汇总--查询顶级机构下的所有类型
     * @param {*} rootId
     */
    getSummaryTypeList(rootId) {
        const url = `/desktopReport/queryCustomerTypeFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:11:23
     * @description: 客户应收--明细--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getDetailsCompanyList(rootId) {
        const url = `/desktopReport/queryCustomerOrgFishMingXi/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:12:47
     * @description: 客户应收--明细--查询顶级机构下的所有类型
     * @param {*} rootId
     */
    getDetailsTypeList(rootId) {
        const url = `/desktopReport/queryCustomerTypeFishMingXi/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:14:39
     * @description: 客户应收--明细--查询顶级机构下的所有客户
     * @param {*} rootId
     */
    getDetailsCustomersList(rootId, breedTypeClass) {
        const url = `/desktopReport/queryCustomersMingXi/${rootId}/${breedTypeClass}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:16:35
     * @description: 销售概览-销售量报表-养成年份分页
     * @param {*} params
     */
    getVolumePageList(params) {
        const url = `/outSaleDailyOrg/searchOutSaleDailyOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:18:07
     * @description: 销售概览-销售量报表分页-（养成、育苗）分页导出
     * @param {*} params
     */
    exportVolumeData(params) {
        const url = `/outSaleDailyOrg/exportOutSaleDailyOrgList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:19:26
     * @description: 销售概览-客户应收养成育苗分页查询
     * @param {*} params
     */
    getCustomersPageList(params) {
        // const url = `/outMoneyReceive/getoutMoneyReceive`;旧
        const url = `/outMoneyReceive/getPresidentOutMoneyReceiveList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-18 17:20:13
     * @description: 销售概览-养成育苗客户应收分页导出
     * @param {*} params
     */
    exportCustomersData(params) {
        // const url = `/outMoneyReceive/exportoutMoneyReceiveList`;
        const url = `/outMoneyReceive/exportPresidentOutMoneyReceiveList`;
        return Page.exportDatas(url, params)
    },
}